import * as React from "react";

const UpArrowIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="72"
    height="72"
    viewBox="0 0 24 24"
  >
    <path
      fill="white"
      d="M11 18V8.8l-3.6 3.6L6 11l6-6 6 6-1.4 1.4L13 8.8V18z"
    ></path>
  </svg>
);

export default UpArrowIcon;
